import React, { useState, useEffect } from 'react';
import {
    View,
    Text,
    TextInput,
    TouchableOpacity,
    Image,
    ImageBackground,
    Animated,
    Platform,
} from 'react-native';
import Checkbox from 'expo-checkbox';
import { Ionicons } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import * as Google from 'expo-auth-session/providers/google';
import * as WebBrowser from 'expo-web-browser';
import MaskInput, { Masks } from 'react-native-mask-input';
import styles from './styles/loginWebStyles';
WebBrowser.maybeCompleteAuthSession();
import { useLogScreen } from '../useLogScreen';

export default function RegisterWeb({ navigation }) {
    useLogScreen('RegisterWeb');
    // STATES
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const creci = null;
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false); // Começa desmarcado
    const [formRegister, setFormRegister] = useState(true);
    const [query, setQuery] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [buttonScale] = useState(new Animated.Value(1));

    const options = [
        'Facebook',
        'Instagram',
        'Google',
        'Loja de aplicativos',
        'Indicação de amigos',
        'Outro'
    ];

    // Google Auth
    const [request, response, promptAsync] = Google.useAuthRequest({
        androidClientId: 'SEU_ANDROID_CLIENT_ID',
        iosClientId: 'SEU_IOS_CLIENT_ID',
        webClientId: '9139107305-8u2mcvrl6cr63uvjdjip4j6622mu9kit.apps.googleusercontent.com',
    });

    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Fazer Cadastro';
            }, 100);
        }
    }, []);

    useEffect(() => {
        if (response?.type === 'success') {
            const { authentication } = response;
            if (authentication?.accessToken) {
                getUserInfo(authentication.accessToken);
            }
        }
    }, [response]);

    // --- UTILS
    const showAlert = (title, message) => {
        window.alert(`${title}: ${message}`);
    };

    const validateEmail = (emailInput) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailInput);
    };

    const handleEmailChange = (emailInput) => {
        setEmail(emailInput);
        setEmailError(validateEmail(emailInput) ? '' : 'Por favor, insira um email válido.');
    };

    const saveLoginInfo = async (usuario_id) => {
        try {
            await AsyncStorage.setItem('usuario_id', usuario_id);
        } catch (error) {
            console.error('Erro ao salvar usuário:', error);
        }
    };

    // --- GOOGLE LOGIN
    const getUserInfo = async (token) => {
        try {
            const res = await fetch('https://www.googleapis.com/userinfo/v2/me', {
                headers: { Authorization: `Bearer ${token}` },
            });
            const userInfo = await res.json();

            const googleLoginData = {
                id_google: userInfo.id,
                nome: userInfo.name,
                email: userInfo.email,
                foto_conta: userInfo.picture,
            };

            await handleGoogleLogin(googleLoginData);
        } catch (error) {
            showAlert('Erro de Login', 'Erro ao obter dados do Google.');
        }
    };

    const handleGoogleLogin = async (googleData) => {
        try {
            const response = await axios.post(
                `https://api.imogo.com.br/api/v1/login/google/corretor`,
                null,
                { params: googleData }
            );
            const data = response.data;
            if (data.usuario_id) {
                await saveLoginInfo(String(data.usuario_id));
                navigation.reset({
                    index: 0,
                    routes: [{ name: 'Home', params: { usuario_id: data.usuario_id } }],
                });
            } else {
                showAlert('Erro de Login', 'ID de usuário não encontrado.');
            }
        } catch (error) {
            showAlert('Erro de Login', error?.response?.data?.detail || 'Erro ao fazer login com o Google.');
        }
    };

    // --- ANIMAÇÃO BOTÃO
    const handleOptionPress = (option) => {
        setSelectedOption(prevOption => (prevOption === option ? null : option));
    };

    const handlePressIn = () => {
        Animated.spring(buttonScale, {
            toValue: 0.95,
            useNativeDriver: true,
        }).start();
    };

    const handlePressOut = () => {
        Animated.spring(buttonScale, {
            toValue: 1,
            useNativeDriver: true,
        }).start();
    };

    // --- CADASTRO
    const handleCreateAccount = async () => {
        if (!selectedOption) {
            showAlert('Atenção', 'Selecione uma opção de como conheceu a imoGo.');
            return;
        }
        if (!nome || !telefone || !email || !password ) {
            showAlert('Atenção', 'Preencha todos os campos obrigatórios.');
            return;
        }
        if (emailError) {
            showAlert('Atenção', 'Preencha um e-mail válido.');
            return;
        }
        if (!remember) {
            showAlert('Atenção', 'Você deve aceitar os Termos e Condições para criar a conta.');
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post('https://api.imogo.com.br/api/v1/usuarios/corretor', {
                email: email,
                nome_social: nome,
                origem: selectedOption || 'Não informado',
                senha: password,
                creci: creci,
                telefone: telefone,
                foto_conta: 'https://juca.eu.org/img/icon_dafault.jpg'
            });
            if (response.data && response.data.id) {
                await saveLoginInfo(String(response.data.id));
                navigation.reset({
                    index: 0,
                    routes: [{ name: 'Home', params: { usuario_id: response.data.id } }],
                });
            } else {
                showAlert('Erro', response.data?.detail || 'Erro ao criar conta. Tente novamente.');
               
            }
        } catch (error) {
            const msg = error?.response?.data?.detail || 'Erro ao criar conta. Tente novamente.';
           
            showAlert('Erro', msg);
        }
        setLoading(false);
    };

    return (
        <ImageBackground
            source={require('../assets/img/bg.png')}
            style={styles.background}
            resizeMode="cover"
        >
            <View style={styles.card}>
                <Image
                    source={require('../assets/img/logo.png')}
                    style={styles.logo}
                    resizeMode="contain"
                />
                {/* PASSO 2 - Como conheceu */}
                {query && (
                    <>
                        <Text style={styles.subtitle} allowFontScaling={false}>Só mais uma coisa</Text>
                        <Text style={styles.title} allowFontScaling={false}>Como conheceu a imoGo?</Text>
                        <Text style={styles.description} allowFontScaling={false}>Nos conte como chegou até aqui</Text>

                        {options.map(option => (
                            <TouchableOpacity
                                key={option}
                                style={[styles.optionButton, selectedOption === option && styles.optionButtonSelected]}
                                onPress={() => handleOptionPress(option)}
                            >
                                <Text style={[styles.optionText, selectedOption === option && styles.optionTextSelected]} allowFontScaling={false}>
                                    {option}
                                </Text>
                                {selectedOption === option && (
                                    <Ionicons name="checkmark" size={20} color="#FFF" style={styles.optionIcon} />
                                )}
                            </TouchableOpacity>
                        ))}

                        <Animated.View style={[styles.buttonContainer, { transform: [{ scale: buttonScale }] }]}>
                            <TouchableOpacity
                                style={[
                                    styles.buttonPrimary,
                                    (loading || !remember) && styles.buttonDisabled
                                ]}
                                onPressIn={handlePressIn}
                                onPressOut={handlePressOut}
                                disabled={loading || !remember}
                                onPress={handleCreateAccount}
                            >
                                <Text style={styles.buttonText} allowFontScaling={false}>
                                    {loading ? 'Criando conta...' : 'Concluir'}
                                </Text>
                            </TouchableOpacity>
                        </Animated.View>
                    </>
                )}

                {/* PASSO 1 - Formulário */}
                {formRegister && (
                    <>
                        <Text style={styles.title}>Crie uma conta!</Text>
                        <View style={styles.row}>
                            <Text style={styles.subLabel}>Nome</Text>
                            <TextInput
                                placeholder="Nome completo"
                                value={nome}
                                onChangeText={setNome}
                                style={styles.input}
                                placeholderTextColor="#A9A9A9"
                                autoCapitalize="words"
                            />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.subLabel}>Telefone</Text>
                            <MaskInput
                                style={styles.input}
                                value={telefone}
                                onChangeText={setTelefone}
                                mask={Masks.BRL_PHONE}
                                placeholder="( )"
                                placeholderTextColor="#A9A9A9"
                                keyboardType="numeric"
                            />
                        </View>                        
                        <View style={styles.hr} />
                        <View style={styles.row}>
                            <Text style={styles.subLabel}>Email</Text>
                            <TextInput
                                placeholder="exemplo@exemplo.com"
                                value={email}
                                onChangeText={handleEmailChange}
                                style={styles.input}
                                placeholderTextColor="#A9A9A9"
                                autoCapitalize="none"
                                keyboardType="email-address"
                            />
                            {emailError ? <Text style={styles.errorText}>{emailError}</Text> : null}
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.subLabel}>Senha</Text>
                            <View style={styles.passwordContainer}>
                                <TextInput
                                    placeholder="Crie uma senha"
                                    value={password}
                                    onChangeText={setPassword}
                                    secureTextEntry={!isPasswordVisible}
                                    style={styles.input}
                                    placeholderTextColor="#A9A9A9"
                                />
                                <TouchableOpacity
                                    onPress={() => setIsPasswordVisible(!isPasswordVisible)}
                                    style={styles.eyeIcon}
                                >
                                    <Ionicons name={isPasswordVisible ? 'eye-off' : 'eye'} size={22} color="#888" />
                                </TouchableOpacity>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.checkboxGroup}>
                                <Checkbox
                                    value={remember}
                                    onValueChange={setRemember}
                                    color="#730d83"
                                />
                                <Text style={styles.checkboxLabel}>Eu li e estou de acordo com os Termos e Condições e com a Política de Privacidade.</Text>
                            </View>
                        </View>
                        <TouchableOpacity
                            style={[
                                styles.buttonPrimary,
                                (!remember) && { opacity: 0.5 }
                            ]}
                            disabled={!remember}
                            onPress={() => {
                                if (!nome || !telefone || !email || !password ) {
                                    showAlert('Atenção', 'Preencha todos os campos obrigatórios.');
                                    return;
                                }
                                if (emailError) {
                                    showAlert('Atenção', 'Preencha um e-mail válido.');
                                    return;
                                }
                                if (!remember) {
                                    showAlert('Atenção', 'Você deve aceitar os Termos e Condições para criar a conta.');
                                    return;
                                }
                                setQuery(true);
                                setFormRegister(false);
                            }}
                        >
                            <Text style={styles.buttonPrimaryText}>Próximo</Text>
                        </TouchableOpacity>
                    </>
                )}

                <Text style={styles.divider}>Ou acesse com</Text>
                <TouchableOpacity style={styles.googleButton} onPress={() => promptAsync()}>
                    <Ionicons name="logo-google" size={22} color="#EA4335" style={styles.googleIcon} />
                    <Text style={styles.googleText}>Continuar com Google</Text>
                </TouchableOpacity>
            </View>
        </ImageBackground>
    );
}
